import { doScrollToTop } from '../global/_scroll';
import { sanitizeInputAgainstXSS } from '../global/_sanitizeInputAgainstXSS.js';
import { disableUnnecessaryFields } from './_disableUnnecessaryFields';

export const submitShippingForm = (form) => {
	//------Check Contact Form Validation--------->
	if ($('#contactInfoInputWrapper').is(':visible')) {
		Dillards.validateThisForm($('#contactInfoInputWrapper'));
		$('#contactInfoInputWrapper button').eq(0).click();
	}
	if ($('#contactInfoInputWrapper .has-error').length > 0) {
		return false;
	}
	//------/Check Contact Form Validation--------->
	if (typeof $('#display-pickup-radio').val() != 'undefined' && $('#display-pickup-radio').prop('checked') && null === $('#storePickUpStores').val()) {
		//doScrollToTop();
		$('.no-store-selected-modal-view').modal('show');
		$('.no-store-selected-modal-view').addClass('in');
	} else if (
		typeof $('#display-curbside-radio').val() != 'undefined' &&
		$('#display-curbside-radio').prop('checked') &&
		null === $('#storeCurbsideStores').val()
	) {
		//doScrollToTop();
		$('.no-curbside-selected-modal-view').modal('show');		
		$('.no-curbside-selected-modal-view').addClass('in');
	} else if (
		typeof $('#holdAtLocationRadio').val() != 'undefined' &&
		$('#holdAtLocationRadio').prop('checked') &&
		$('.address-checkout-hal:hidden').length > 0
	) {
		//doScrollToTop();
		$('.no-hal-selected-modal-view').modal('show');		
		$('.no-hal-selected-modal-view').addClass('in');
	} else {
		//------Form Validation for bopis phone number status update--------->
		if ($('.bopis-text-notifications-phone').is(':visible')) {
			Dillards.validateThisForm($('#optInText'));
			$('#optInText button').eq(0).click();
		} else {
			$('#optInText div').removeClass('has-error');
			$('#optInText p').remove('.txt-error');
		}
		if ($('.bopis-text-notifications-phone').is(':visible') && $('#optInText .has-error').length > 0) {
			return false;
		}
		//------/Form Validation for bopis phone number status update--------->

		//------Form Validation for hal phone number status update--------->
		if ($('.hal-text-notifications-phone').is(':visible')) {
			Dillards.validateThisForm($('#halOptInText'));
			$('#halOptInText button').eq(0).click();
		} else {
			$('#halOptInText div').removeClass('has-error');
			$('#halOptInText p').remove('.txt-error');
		}
		if ($('.hal-text-notifications-phone').is(':visible') && $('#halOptInText .has-error').length > 0) {
			return false;
		}
		//------/Form Validation for hal phone number status update--------->

		//------Form Validation for curbside phone number status update--------->
		if ($('.curbside-text-notifications-phone').is(':visible')) {
			Dillards.validateThisForm($('#curbsideOptInText'));
			$('#curbsideOptInText button').eq(0).click();
		} else {
			$('#curbsideOptInText div').removeClass('has-error');
			$('#curbsideOptInText p').remove('.txt-error');
		}
		if ($('.curbside-text-notifications-phone').is(':visible') && $('#curbsideOptInText .has-error').length > 0) {
			return false;
		}
		//------/Form Validation for hal phone number status update--------->

		sanitizeGiftMessages();
		disableUnnecessaryFields();
		setOptInPhoneNum();
		setContactInfo();
		form.URL.value = 'OrderPaymentMethodDelete?quantity_*=&orderItemId_*=&shipmodeId_*=&addressId_*=&URL=OrderPaymentCmd';
		if (typeof history.pushState !== 'undefined') {
			window.history.replaceState(
				null,
				null,
				'OrderShippingMethodCmd?orderId=' + form.orderId.value + '&storeId=301&catalogId=301&langId=-1&guestCheckout=&edit=true'
			);
		}
		$(form).submit();
	}
};

const setOptInPhoneNum = () => {
	var optInPhoneNum = '';
	if ($('#display-pickup-radio').prop('checked') && typeof $('#bopis-phone').val() != 'undefined') {
		optInPhoneNum = $('#bopis-phone').val();
	} else if ($('#display-curbside-radio').prop('checked') && typeof $('#curbside-phone').val() != 'undefined') {
		optInPhoneNum = $('#curbside-phone').val();
	} else if ($('#holdAtLocationRadio').prop('checked') && typeof $('#hal-phone').val() != 'undefined') {
		optInPhoneNum = $('#hal-phone').val();
	}
	if (optInPhoneNum != '') {
		optInPhoneNum = optInPhoneNum.split(' ').join('').split('(').join('').split(')').join('').split('-').join('');
		$('#optInPhoneNum').val(optInPhoneNum);
	}
};

const setContactInfo = () => {
	var orderPhone = $('#contactPhone').val();
	if (orderPhone != '') {
		orderPhone = orderPhone.split(' ').join('').split('(').join('').split(')').join('').split('-').join('');
		$('#orderPhone').val(orderPhone);
	}
	var orderEmail = $('#contactEmail').val();
	if (orderEmail != '') {
		$('#orderEmail').val(orderEmail);
	}
	var orderTextOptIn = $('#textOptInCheckbox').val();
	if (orderTextOptIn != '') {
		$('#orderTextOptIn').val(orderTextOptIn);
	}
};

const sanitizeGiftMessages = () => {
	$('.gift-message').val(sanitizeInputAgainstXSS($('.gift-message').val()));
	$('.gift-item-message').each(function () {
		this.value = sanitizeInputAgainstXSS(this.value);
	});
};
